<template>
    <div v-if="result && result.picture" class="banner-thanks"
         :style="`background-image: url(${result.picture.src})`"
         :class="{'banner-thanks_center': result.centerMode}">
        <div class="banner-thanks__block">
            <h2 class="def-title-2">{{result.title}}</h2>
            <p class="banner-thanks__text-big">{{result.textBig}}</p>
            <p class="banner-thanks__text-small">{{result.textSmall}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'banner-thanks',
        props: {
            result: {
                type: Object,
                default: () => ({
                    title: 'дякуємо за замовлення',
                    textBig: 'Ваше замовлення № 1234560 успішно оформлено',
                    textSmall: 'На ваш e-mail marinalebedeva@gmail.com відправлено лист з деталями замовлення',
                    picture: {
                        src: '/local/templates/love-you/images/front-end/banner-thanks.png'
                    },
                    centerMode: true
                })
            }
        }
    }
</script>
<style lang="scss">
    .banner-thanks{
        display: flex;
        align-items: center;
        min-height: 260px;
        padding: 16px;
        margin-bottom: 4px;
        @include point-md{
            padding: 24px;
        }
        @include point-lg{
            padding: 64px;
        }
        &_center{
            justify-content: center;
            text-align: center;
        }
        &__text-big{
            font-weight: 500;
            font-size: rem(16);
            line-height: 120%;
            color: #363636;
            margin-bottom: 8px;
            @include point-md{
                font-size: rem(18);
            }
        }
        &__text-small{
            font-size: rem(12);
            line-height: 100%;
            @include point-md{
                font-size: rem(14);
            }
        }
        .def-title-2{
            line-height: 110%;
            color: #467496;
            margin-bottom: 16px;
        }
    }
</style>